import React from 'react';
import moment from "moment";
import { toWords } from 'number-to-words';
import {InvoiceHeader} from '../common/InvoiceHeader';
import {InvoiceFooter} from '../common/InvoiceFooter';

const ExpenseInvoice = React.forwardRef(({ data }, ref) => {
  const { supplier, products } = data;

  return (
    <div ref={ref} className="bg-gray-200 print:bg-white py-6 print:py-0">
      <style>{`
        @media print {
          @page { size: A4; margin: 10mm; }
          body { background: white; }
        }
      `}</style>

      <div className="w-[210mm] min-h-[297mm] mx-auto bg-white text-[12px] leading-relaxed">
        {/* Header */}
        <InvoiceHeader />

        {/* Title */}
        <div className="text-center font-bold text-lg py-2 border-b border-gray-300">
          EXPENSE INVOICE
        </div>

       <div className="grid grid-cols-2 gap-4 p-4 border-b border-gray-300">
              <div className="border border-gray-300 p-3">
                <h3 className="font-bold mb-2">Expense Information</h3>
                <p>
                  <span className="font-semibold">Branch:</span> {data?.branchName}
                </p>
                 <p>
                  <span className="font-semibold">Branch Number:</span> {data?.branchNumber}
                </p> 
                 <p>
                  <span className="font-semibold">Receiver Name:</span> {data?.receiverName}
                </p>
                <p>
                  <span className="font-semibold">Receiver Number:</span>{" "}
                  {data?.receiverPhone}
                </p>
  
                <p>
                  <span className="font-semibold">Note:</span>{" "}
                  {data?.phone}
                </p>
                <p>
                  <span className="font-semibold">Ref No:</span>{" "}
                  {data?.ref}
                </p>
              </div>
    
              <div className="border border-gray-300 p-3">
                <h3 className="font-bold mb-2">Invoice Details</h3>
                

                <p>
                  <span className="font-semibold">Invoice Number:</span>{" "}
                   {data?.invoiceNumber}
                </p>

               

                <p>
                  <span className="font-semibold">Expense Date:</span>
                  {moment(data?.expenseDate).format("DD/MM/YYYY, h:mm A")}
                </p>
                <p>
                  <span className="font-semibold">Prepared By:</span>
                  {data?.createBy?.name}
                </p>
                  <p>
                  <span className="font-semibold">Prepared By Number:</span>
                  {data?.createBy?.phone}
                </p>
                <p>
                  <span className="font-semibold">Prepared Date:</span>
                  {moment().format("DD/MM/YYYY, h:mm A")}
                </p>
              </div>
            </div>
    

          {/* Table */}
        <div className="p-4">
          <table className="w-full border border-gray-300">
            <thead className="bg-gray-100">
              <tr>
                <th className="border border-gray-300 p-2">SL</th>
                <th className="border border-gray-300 p-2 text-left">
                  Product Description
                </th>
                <th className="border border-gray-300 p-2">Category</th>
                <th className="border border-gray-300 p-2">Unit</th>
                <th className="border border-gray-300 p-2">Warranty</th>
                <th className="border border-gray-300 p-2">Qty</th>
                <th className="border border-gray-300 p-2">Unit Price</th>
                <th className="border border-gray-300 p-2">Amount</th>
              </tr>
            </thead>
            <tbody>
              {products?.map((product, index) => (
                <tr>
                  <td className="border border-gray-300 p-2 text-center">{index+1}</td>
                  <td className="border border-gray-300 p-2">
                         <div className="font-medium text-gray-900">
                            {product.product.name}
                          </div>

                          <div className="flex flex-wrap gap-1 mt-2">
                            S/N:
                            {product?.skus?.map((sku, index) => (
                              <span
                                key={index}
                                className="px-2 py-0.5 text-xs bg-gray-100 text-gray-700 rounded"
                              >
                                {sku}
                              </span>
                            ))}
                          </div>
                  </td>
                  <td className="border border-gray-300 p-2 text-center">
                    {product?.product?.category}
                  </td>
                  <td className="border border-gray-300 p-2 text-center">
                    {product?.product?.unit}
                  </td>
                  <td className="border border-gray-300 p-2 text-center">
               { product.warrantyExpireDate ?   moment(product.warrantyExpireDate).format("DD/MM/YYYY") : 'No' }
                      
                  </td>
                  <td className="border border-gray-300 p-2 text-center">
                    {product?.quantity}
                  </td>
                  <td className="border border-gray-300 p-2 text-right">
                    {product?.price}
                  </td>
                  <td className="border border-gray-300 p-2 text-right">
                    {product?.price * product?.quantity}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Totals */}
          <div className="grid grid-cols-2 mt-4">
            <div className="font-semibold">
              In Word: {toWords(data?.totalAmount)}
            </div>
            <div>
              <div className="flex justify-between border-b border-gray-300 py-1">
                <span>Total Amount</span>
                <span>{data?.subTotal}</span>
              </div>
              <div className="flex justify-between border-b border-gray-300 py-1">
                <span>Discount</span>
                <span>{data?.discount}</span>
              </div>
              <div className="flex justify-between border-b border-gray-300 py-1">
                <span>VAT</span>
                <span>0.00</span>
              </div>
              <div className="flex justify-between font-bold text-base pt-2">
                <span>Net Payable Amount</span>
                <span>{data?.totalAmount}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <InvoiceFooter />
      </div>
    </div>
  );
});

export default ExpenseInvoice;